<div class="header" [ngClass]="{open: isOpen == true, scroll: isScroll == true}" (mouseleave)="closeMenu()">
  <div class="wrap">
    <a routerLink="/en" class="top-logo">
      <img src="/assets/images/e_logo.png" alt="LOGO" />
    </a>

    <div class="gnb">
		<ul class="main-menu" (mouseenter)="expandMenu()">

			<li *ngFor="let menu of menuList; let i = index">
        <a class="dot" [ngClass]="{on: menu_on == i.toString()}" (click)="goLink($event, [menu], i)">
          {{menu['page_menu_name']}}<span class="dot"></span>
        </a>

        <ul class="sub-menu">
          <li *ngFor="let item of menu['children']">
            <ng-container *ngIf="item.link_open_yn == 'N'">
              <ng-container *ngIf="item.link_url.includes('http'); else route">
                <a [href]="item.link_url" target="_blank">{{item.page_menu_name}}</a>
              </ng-container>
              <ng-template #route>
                <a [routerLink]="item.link_url" target="_blank">{{item.page_menu_name}}</a>
              </ng-template>
            </ng-container>

            <ng-container *ngIf="item.link_open_yn == 'C'">
              <a [routerLink]="" (click)="goLink($event, [item], -1)">{{item.page_menu_name}}</a>
            </ng-container>
          </li>
        </ul>
      </li>

    </ul>

		<a routerLink="/main" class="kor">KOR</a>
    </div>
  </div>
</div>
